import { useMemo } from "react";
import { getHereTileUrl } from "../../../helpers/hereTileHelper"; 

type UseHereTileUrlsOpts = {
  apiKey?: string;
  lang?: string;
  ppi?: 72 | 92 | 120 | 160 | 320;
};

export type TileUrls = {
  day: string;
  sat: string;
  hybrid: string;
};

export function useHereTileUrls(
  { apiKey, lang = "en", ppi }: UseHereTileUrlsOpts
): TileUrls {
  return useMemo(() => {
    const key = apiKey || (process.env.REACT_APP_HERE_MAPS_API_KEY as string) || "";

    return {
      day: getHereTileUrl({ apiKey: key, style: "explore.day", lang }),
      sat: getHereTileUrl({ apiKey: key, style: "satellite.day", lang }),
      hybrid: getHereTileUrl({ apiKey: key, style: "explore.satellite.day", lang }),
    };
  }, [apiKey, lang, ppi]);
}
